import axios from "./axios-config";

export const uploadImage = async (file) => {

    let { data } = await axios.post(`/super-admin/upload-image`,file,{
        "Content-Type": "multipart/form-data"
    })
    return data;

}
export const uploadVideo = async (file) => {

    let { data } = await axios.post(`/super-admin/upload-video`,file,{
        "Content-Type": "multipart/form-data"
    })
    return data;

}